// This file include all search related the keys of
// action to perform calls to the reducer or sagas.

// This object define all the search action keys.
const searchActions = Object.freeze({
    SEARCH_ON_LOAD_START: 'SEARCH_ON_LOAD_START',
    SEARCH_RESET_STATE_SUCCESS: 'SEARCH_RESET_STATE_SUCCESS',
    SEARCH_OPTIONS_TOGGLE_SUCCESS: 'SEARCH_OPTIONS_TOGGLE_SUCCESS',
    SEARCH_OPTION_CHANGE_START: 'SEARCH_OPTION_CHANGE_START',
    SEARCH_OPTION_CHANGE_ERROR: 'SEARCH_OPTION_CHANGE_ERROR',
    SEARCH_OPTION_CHANGE_SUCCESS: 'SEARCH_OPTION_CHANGE_SUCCESS',
    SEARCH_MODE_CHANGE_START: 'SEARCH_MODE_CHANGE_START',
    SEARCH_MODE_CHANGE_SUCCESS: 'SEARCH_MODE_CHANGE_SUCCESS',
    SEARCH_KEY_CHANGE_SUCCESS: 'SEARCH_KEY_CHANGE_SUCCESS',
    SEARCH_PROCESS_START: 'SEARCH_PROCESS_START',
    SEARCH_PROCESS_PREPARATION: 'SEARCH_PROCESS_PREPARATION',
    SEARCH_PROCESS_VALIDATION_ERROR: 'SEARCH_PROCESS_VALIDATION_ERROR',
    SEARCH_PROCESS_SUCCESS: 'SEARCH_PROCESS_SUCCESS',
    SEARCH_PROCESS_FAIL: 'SEARCH_PROCESS_FAIL',
    SEARCH_MODAL_TOGGLE_START: 'SEARCH_MODAL_TOGGLE_START',
    SEARCH_MODAL_TOGGLE_SUCCESS: 'SEARCH_MODAL_TOGGLE_SUCCESS',
    SEARCH_ADD_EMAIL_MODAL_TOGGLE_START: 'SEARCH_ADD_EMAIL_MODAL_TOGGLE_START',
    SEARCH_ADD_EMAIL_MODAL_TOGGLE_SUCCESS: 'SEARCH_ADD_EMAIL_MODAL_TOGGLE_SUCCESS',
    SEARCH_ADD_EMAIL_MODAL_TOGGLE_RESET: 'SEARCH_ADD_EMAIL_MODAL_TOGGLE_RESET',
    SEARCH_ADD_EMAIL_COMMENTS_CHANGE_SUCCESS: 'SEARCH_ADD_EMAIL_COMMENTS_CHANGE_SUCCESS',
    SEARCH_ADD_EMAIL_PROCESS_START: 'SEARCH_ADD_EMAIL_PROCESS_START',
    SEARCH_ADD_EMAIL_PROCESS_PREPARATION: 'SEARCH_ADD_EMAIL_PROCESS_PREPARATION',
    SEARCH_ADD_EMAIL_PROCESS_ERROR: 'SEARCH_ADD_EMAIL_PROCESS_ERROR',
    SEARCH_ADD_EMAIL_PROCESS_SUCCESS: 'SEARCH_ADD_EMAIL_PROCESS_SUCCESS',
    SEARCH_ADD_EMAIL_PROCESS_FAIL: 'SEARCH_ADD_EMAIL_PROCESS_FAIL'
});

export default searchActions;